import React, { useContext, useEffect, useRef, useState } from 'react'
import './Ratibsabhasad.css'
import { ToastContainer, toast } from 'react-toastify';
import back from "../../imgs/backexam.png";
import cash from "../../imgs/cash.png";
import close from "../../imgs/close.png";
import { Face6TwoTone, FaxTwoTone, Preview } from '@mui/icons-material';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import { compareSync } from 'bcryptjs';
import Ratibjma from '../Ratibjma/Ratibjma';
import { useTranslation } from "react-i18next";

const Ratibsabhasad = (props) => {
    const { t } = useTranslation();

    // ✅ language-independent placeholders (important for validation + backspace logic)
    const SELECT_TIME = "__select_time__";
    const SELECT_TYPE = "__select_type__";

    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({
        date: new Date().toISOString().substr(0, 10),
        time: SELECT_TIME,
        grtype: "सभासद",
        rno: "",
        rname: "",
        type: SELECT_TYPE,
        liter: "",
        rate: "",
        amt: "",
        mhrate: "",
        gayrate: "",
        etype: "उधारी"
    });

    const [comm, setComm] = useState({ mhcomm: "", gaycomm: "" });
    const inputRefs = useRef([]);
    const [tcust, setTcust] = useState({ tcust: "", tcompleted: "", tliter: 0, tavg: 0, tmh: 0, mhavg: 0, tgay: 0, gayavg: 0 });
    const [sredit, setSredit] = useState('');
    const [DataSource, setDataSource] = useState([]);
    const { sanksource, setSanksource, setHeadname } = useContext(Globalcontext);
    const [Prevdata, setPrevdata] = useState([]);
    const [kopen, setkopen] = useState(0);
    const [transitionEnded, setTransitionEnded] = useState(true);
    const [Prev, setPrev] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [value, setValue] = useState('');
    const [custdata, setCustdata] = useState([]);
    const { submenu, setsubmenu, newcustsource, setNewcustsource, custlist, setCustlist } = useContext(Globalcontext);
    const [tableFilter2, setTableFilter2] = useState([]);
    const [sendMsg, setSendmsg] = useState(true);
    const [custSank, SetCustsank] = useState(false);
    const [mastermenu, setMastermenu] = useState(true);

    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const refdelete = useRef(null);
    const refdeleteclose = useRef(null);
    const [flag, setFlag] = useState("");

    const [expanded, setExpanded] = useState(false);
    const navigate = useNavigate();

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setsubmenu("");
        setHeadname(t("Ratibsabhasad.headers.dailyTransactions"));
    }

    const openratibjma = (flag) => {
        setsubmenu("ratibjmasabh");
        setHeadname(t("Ratibsabhasad.headers.ratibDepositMember"));
    };

    useEffect(() => {
        if (expanded === true) {
            if (flag === "total") {
                getcustlist(flag);
            }
        }
    }, [expanded])

    async function getcustlist(flag) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getcustlisttemp.php', { flag: flag, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data.length > 0) {
                setCustdata(response.data);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleedit = (sr, date, time, grtype, rno, rname, type, liter, rate, amt, etype) => {
        setNewedit("edit");
        setInput({
            date: date,
            time: time || SELECT_TIME,
            grtype: grtype || "सभासद",
            rno: rno,
            rname: rname,
            type: type || SELECT_TYPE,
            liter: liter,
            rate: rate,
            amt: amt,
            etype: etype || "उधारी",
            mhrate: input.mhrate,
            gayrate: input.gayrate
        })
        setSredit(sr);

        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }

    async function getratibcustomer() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);

        axios.post('https://excellentdairy.com/dairy/php/cust/getratibcustomer.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                localStorage.setItem("sanghlist", JSON.stringify(response.data));

                const currentHour = new Date().getHours();
                const timeValue = currentHour < 15 ? "Morning" : "Evening";
                console.log(timeValue);

                // If you want auto-set time, uncomment:
                // setInput(prev => ({ ...prev, time: timeValue }));
            }
            else {
                setInput(prev => ({ ...prev, rno: 1 }))
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    const handleChangefs = e => {
        const { name, value } = e.target;

        if (value === "") {
            setInput(prevInput => ({
                ...prevInput,
                [name]: value
            }));
        } else if (/^\d*(\.\d{0,1})?$/.test(value)) {
            setInput(prevInput => ({
                ...prevInput,
                [name]: value
            }));
        }
    };

    useEffect(() => {
        if (localStorage.getItem("sankdate") && localStorage.getItem("sanktime")) {
            setInput(prevInput => ({
                ...prevInput,
                date: localStorage.getItem("sankdate"),
                time: localStorage.getItem("sanktime") || SELECT_TIME
            }))

            localStorage.setItem("sankdate", "");
            localStorage.setItem("sanktime", "")
        }

        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
        getratibcustomer();
    }, [])

    useEffect(() => {
        if (input.rno === "") {
            setInput(prevInput => ({
                ...prevInput,
                rno: "",
                rname: "",
                type: SELECT_TYPE,
                liter: "",
                rate: "",
                amt: ""
            }))
            setSredit("");
            setNewedit("new");
        }
        else {
            if (newedit === 'new') {
                let custlisttemp = "";
                custlisttemp = JSON.parse(localStorage.getItem("custlist"));

                for (let i = 0; i < custlisttemp.length; i++) {
                    setInput(prevInput => ({
                        ...prevInput,
                        rname: '',
                    }));
                    const user = custlisttemp[i];
                    if (user.kno === input.rno) {
                        setInput(prevInput => ({
                            ...prevInput,
                            rname: user.cname,
                            mhrate: user.mhrate,
                            gayrate: user.gayrate
                        }));
                        break;
                    }
                }
            }
        }
    }, [input.rno])

    useEffect(() => {
        if (newedit === "new") {
            if (input.type !== SELECT_TYPE) {
                setInput(prevInput => ({
                    ...prevInput,
                    rate: "",
                    amt: "",
                    type: input.type
                }))
            }
            if (input.type === "Buffalo" && newedit === "new") {
                setInput(prevInput => ({
                    ...prevInput,
                    rate: input.mhrate,
                }))
            }
            else if (input.type === "Cow" && newedit === "new") {
                setInput(prevInput => ({
                    ...prevInput,
                    rate: input.gayrate,
                }))
            }
        }
    }, [input.type])

    useEffect(() => {
        if (input.liter === "") {
            setInput(prevInput => ({
                ...prevInput,
                amt: "0",
                comm: "0"
            }))
        }
        else if (input.liter !== "") {
            if (input.type === "Buffalo") {
                if (comm.mhcomm !== "") {
                    setInput(prevInput => ({
                        ...prevInput,
                        comm: parseFloat(parseFloat(comm.mhcomm) * parseFloat(input.liter)).toFixed(2)
                    }))
                }
            }
            else if (input.type === "Cow") {
                if (comm.gaycomm !== "") {
                    setInput(prevInput => ({
                        ...prevInput,
                        comm: parseFloat(parseFloat(comm.gaycomm) * parseFloat(input.liter)).toFixed(2)
                    }))
                }
            }

            if (input.rate !== "") {
                setInput(prevInput => ({
                    ...prevInput,
                    amt: parseFloat(parseFloat(input.rate) * parseFloat(input.liter)).toFixed(2),
                }))
            }
        }
    }, [input.liter])

    useEffect(() => {
        setExpanded(false);
        if (input.time && input.time !== SELECT_TIME) {
            if (input.date) {
                getsanghvikri();
            }
        }
        else {
            setTcust({ tcust: "", tcompleted: "" });
        }
    }, [input.time])

    useEffect(() => {
        if (input.date && input.time && input.time !== SELECT_TIME) {
            getsanghvikri();
        }

        const selectedDate = new Date(input.date);
        const currentDate = new Date();
        const isToday = selectedDate.toDateString() === currentDate.toDateString();
        setSendmsg(isToday);

        setPrev([]);
        setInput(prevInput => ({
            ...prevInput,
            time: SELECT_TIME
        }))
        setTcust({ tcust: "", tcompleted: "", tliter: 0, tavg: 0, tmh: 0, mhavg: 0, tgay: 0, gayavg: 0 });
    }, [input.date])

    async function getoldentry() {
        DataSource
            .filter(data => data.rno === input.rno && data.type === input.type && data.grtype === input.grtype)
            .map((user, index) => (
                handleedit(user.sr, user.date, user.time, user.grtype, user.rno, user.grtype === 'रतीब' ? user.rname : user.grtype === "सभासद" ? user.sname : '', user.type, user.liter, user.rate, user.amt, user.etype)
            ));
        getprevfatsnf2()
    }

    const getprevfatsnf2 = () => {
        for (let i = 0; i < Prevdata.length; i++) {
            const user = Prevdata[i];
            if (user.kno === input.rno && user.type === input.type && user.time === input.time) {
                setPrev((prevInputSettings) => ({
                    ...prevInputSettings,
                    liter: user.liter,
                    fat: user.fat,
                    snf: user.snf,
                }));
                break;
            }
        }
    }

    async function getsanghvikri() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getratibvikrisabhdate.php', { date: input.date, time: input.time, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKey(event, currentIndex) {

        if (event.keyCode === 8) {
            if (event.target.name === "time") {
                setInput((prev) => ({ ...prev, time: SELECT_TIME }));
            }
            else if (event.target.name === "type") {
                setInput((prev) => ({ ...prev, type: SELECT_TYPE }));
            }
            else if (event.target.name === "grtype") {
                setInput((prev) => ({ ...prev, grtype: "सभासद" }));
            }
        }

        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === SELECT_TYPE) ||
                (event.target.name === 'time' && event.target.value === SELECT_TIME)
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if ((prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') && prevElement !== event.target) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;

            if (currentIndex === 3) {
                if (input.rname !== "") nextIndex = currentIndex + 1;
                else nextIndex = currentIndex;
            } else {
                nextIndex = currentIndex + 1;
            }

            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
    }

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            saveratibvikri();

            if (custSank) {
                if (inputRefs.current[1]) {
                    inputRefs.current[1].focus();
                }
            }
            else {
                let nextIndex = null;
                if (currentIndex === 0) {
                    if (input.rname !== "") nextIndex = currentIndex + 1;
                    else nextIndex = currentIndex;
                } else {
                    nextIndex = currentIndex + 1;
                }
                if (inputRefs.current[nextIndex]) {
                    inputRefs.current[nextIndex].focus();
                }
            }
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[5]) {
                    inputRefs.current[5].focus();
                }
            }
        }
    }

    async function deletesanklan(sr, date, time, kno, type, grtype) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/deleteratibvikrisabh.php', { sr: sr, date: date, time: time, kno: kno, type: type, grtype: grtype, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                notify(response.data);
                setInput(prevInput => ({
                    ...prevInput,
                    kno: "",
                    sname: "",
                    type: SELECT_TYPE,
                    liter: "",
                    fat: "",
                    snf: "",
                    rate: "",
                    amt: ""
                }))
                setSredit("");
                setNewedit("new");
                removeentry(date, time, kno, type, grtype);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const saveratibvikri = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);

        if (
            input.date === "" ||
            input.time === "" || input.time === SELECT_TIME ||
            input.grtype === "" ||
            input.rno === "" ||
            input.rname === "" ||
            input.type === "" || input.type === SELECT_TYPE ||
            input.liter === "" ||
            input.rate === "" ||
            input.amt === ""
        ) {
            notifyerror(t("Ratibsabhasad.toast.incompleteEntry"));
            return;
        }

        let rawData = {
            date: input.date,
            time: input.time,
            etype: input.etype,
            grtype: input.grtype,
            rno: input.rno,
            type: input.type,
            liter: input.liter,
            rate: input.rate,
            amt: input.amt,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit,
            sredit: sredit,
        }

        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/saveratibvikirsabh.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (response.data.trim() === "Successfully saved.".trim()) {
                notify(t("Ratibsabhasad.toast.entrySaved"));

                if (custSank) {
                    setNewedit("new");
                    insertnewentry();
                    setPrev([]);
                    setInput(prevInput => ({
                        ...prevInput,
                        time: SELECT_TIME,
                        grtype: "सभासद",
                        type: SELECT_TYPE,
                        liter: "",
                        fat: "",
                        snf: "",
                        comm: "",
                        rate: "",
                        amt: ""
                    }))
                }
                else {
                    setSredit("");
                    setNewedit("new");
                    insertnewentry();
                    setPrev([]);
                    setInput(prevInput => ({
                        ...prevInput,
                        rno: "",
                        rname: "",
                        type: SELECT_TYPE,
                        liter: "",
                        rate: "",
                        amt: ""
                    }))
                }
            }
            else if (response.data.trim() === "Successfully updated.".trim()) {
                notify(t("Ratibsabhasad.toast.updated"));
                updateentry();
                setSredit("");
                setNewedit("new");
                setPrev([]);
                setInput(prevInput => ({
                    ...prevInput,
                    rno: "",
                    rname: "",
                    type: SELECT_TYPE,
                    liter: "",
                    rate: "",
                    amt: ""
                }))
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const opensanklan = (flag) => {
        setsubmenu("sanklan");
        setHeadname(t("Ratibsabhasad.headers.collection"));
    };

    const insertnewentry = () => {
        const newItem = {
            sr: "new",
            date: input.date,
            time: input.time,
            grtype: input.grtype,
            rno: input.rno,
            type: input.type,
            liter: input.liter,
            rate: input.rate,
            amt: input.amt,
            mainuser: localStorage.getItem("contact"),
            rname: input.rname,
            sname: input.rname,
            tcustomer: "0"
        };
        setDataSource((prevDataSource) => [newItem, ...prevDataSource]);
    }

    useEffect(() => {
        const totals = DataSource.reduce(
            (acc, user) => {
                const liter = parseFloat(user.liter || 0);
                const fat = parseFloat(user.fat || 0);

                acc.totalLiter += liter;
                acc.tfat += fat;

                if (user.type === "Buffalo") {
                    acc.totalLitermh += liter;
                    acc.tfatmh += fat;
                    acc.tentrymh += 1;
                } else if (user.type === "Cow") {
                    acc.totalLitergay += liter;
                    acc.tfatgay += fat;
                    acc.tentrygay += 1;
                }
                return acc;
            },
            {
                totalLiter: 0, tfat: 0,
                totalLitermh: 0, tfatmh: 0, tentrymh: 0,
                totalLitergay: 0, tfatgay: 0, tentrygay: 0,
            }
        );

        const {
            totalLiter, tfat,
            totalLitermh, tfatmh, tentrymh,
            tfatgay, tentrygay, totalLitergay,
        } = totals;

        setTcust(prev => ({
            ...prev,
            tliter: totalLiter.toFixed(2),
            tavg: DataSource.length > 0 ? (parseFloat(tfat) / parseFloat(DataSource.length)).toFixed(1) : 0,
            tmh: totalLitermh.toFixed(2),
            mhavg: tentrymh > 0 ? (parseFloat(tfatmh) / parseFloat(tentrymh)).toFixed(1) : 0,
            tgay: totalLitergay.toFixed(2),
            gayavg: tentrygay > 0 ? (parseFloat(tfatgay) / parseFloat(tentrygay)).toFixed(1) : 0,
            tcompleted: DataSource.length,
        }));
    }, [DataSource])

    const updateentry = () => {
        const modifiedItem = {
            date: input.date,
            time: input.time,
            grtype: input.grtype,
            rno: input.rno,
            type: input.type,
            liter: input.liter,
            rate: input.rate,
            amt: input.amt,
            mainuser: localStorage.getItem("contact"),
            rname: input.rname,
            tcustomer: "0"
        };

        const updatedDataSource = DataSource.map((item) => {
            if (item.rno === input.rno && item.type === input.type && item.grtype === input.grtype) {
                return { ...item, ...modifiedItem };
            } else {
                return item;
            }
        });

        setDataSource(updatedDataSource);
    }

    const removeentry = (date, time, kno, type, grtype) => {
        const updatedDataSource = DataSource.filter((item) => !(item.rno === kno && item.type === type && item.grtype === grtype));
        setDataSource(updatedDataSource);
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    useEffect(() => {
        setInput({
            date: new Date().toISOString().substr(0, 10),
            time: SELECT_TIME,
            kno: "",
            name: "",
            type: SELECT_TYPE,
            liter: "",
            fat: "",
            snf: "",
            rate: "",
            amt: "",
            etype: 'उधारी',
            grtype: "सभासद",
            rno: "",
            rname: "",
            mhrate: "",
            gayrate: ""
        });
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, [custSank])

    return (
        <div className="sanklanmain">
            <div className="firstrowsank">
                <img onClick={opensanklan} className='back' src={back} alt="" />
                <div className="colmain">
                    <div className="firstrow2">
                        <div className="rowsankratib">
                            <div className="rowsank">
                                <div className="mb-2">
                                    <span className='subheadsank'>{t("Ratibsabhasad.fields.date")}</span>
                                    <input
                                        onKeyDown={e => handleEnterKey(e, 0)}
                                        ref={ref => (inputRefs.current[0] = ref)}
                                        type="date"
                                        className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                                        autoComplete='off'
                                        id="date"
                                        name="date"
                                        value={input.date}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-2">
                                    <span className='subheadsank'>{t("Ratibsabhasad.fields.time")}</span>
                                    <select
                                        onKeyDown={e => handleEnterKey(e, 1)}
                                        ref={ref => (inputRefs.current[1] = ref)}
                                        autoComplete='off'
                                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                                        id="timeratib"
                                        name="time"
                                        value={input.time}
                                        onChange={handleChange}
                                    >
                                        <option key={0} value={SELECT_TIME}>{t("Ratibsabhasad.placeholders.selectTime")}</option>
                                        <option key={1} value="Morning">{t("Ratibsabhasad.options.morning")}</option>
                                        <option key={2} value="Evening">{t("Ratibsabhasad.options.evening")}</option>
                                    </select>
                                </div>

                                <div hidden className="mb-2">
                                    <span className='subheadsank'>{t("Ratibsabhasad.fields.customerGroupType")}</span>
                                    <select
                                        autoComplete='off'
                                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                                        id="grtyperatib"
                                        name="grtype"
                                        value={input.grtype}
                                        onChange={handleChange}
                                    >
                                        <option key={0} value="सभासद">{t("Ratibsabhasad.options.member")}</option>
                                    </select>
                                </div>

                                <div className='classvauditentry' >
                                    <label>
                                        <div id='udharirokh' className="classbox">
                                            <div className='vlineclass'></div>

                                            {["उधारी", "रोख"].map((etype) => (
                                                <label key={etype}>
                                                    <div className='classbox'>
                                                        <input
                                                            type="radio"
                                                            name="etype"
                                                            value={etype}
                                                            checked={input.etype === etype}
                                                            onChange={(e) => {
                                                                setInput(value => ({ ...value, etype: e.target.value }))
                                                            }}
                                                        />
                                                        <span className='classspan'>
                                                            {etype === "उधारी"
                                                                ? t("Ratibsabhasad.options.udhari")
                                                                : t("Ratibsabhasad.options.rokh")}
                                                        </span>
                                                        <div className='vlineclass'></div>
                                                    </div>
                                                </label>
                                            ))}
                                        </div>
                                    </label>
                                </div>
                            </div>

                            <div onClick={openratibjma} className="rightratib">
                                <img className='backratib' src={cash} alt="" />
                                <span className='subheadsankratib'>{t("Ratibsabhasad.buttons.ratibDeposit")}</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className='linesank' />

            <div className="row1sank">
                <div className="row1sank">
                    <div className="mb-2">
                        <span className='subheadsank'>{t("Ratibsabhasad.fields.customerNo")}</span>
                        <input
                            onKeyDown={e => handleEnterKey(e, 2)}
                            ref={ref => (inputRefs.current[2] = ref)}
                            type="number"
                            className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                            autoComplete='off'
                            id="rno"
                            name="rno"
                            value={input.rno}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="mb-2">
                        <span className='subheadsank'>{t("Ratibsabhasad.fields.customerName")}</span>
                        <input
                            type="text"
                            disabled
                            className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                            autoComplete='off'
                            id="rname"
                            name="rname"
                            value={input.rname}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibsabhasad.fields.type")}</span>
                    <select
                        onBlur={getoldentry}
                        onKeyDown={e => handleEnterKey(e, 3)}
                        ref={ref => (inputRefs.current[3] = ref)}
                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                        id="type"
                        name="type"
                        value={input.type}
                        onChange={handleChange}
                    >
                        <option key={0} value={SELECT_TYPE}>{t("Ratibsabhasad.placeholders.selectType")}</option>
                        <option key={1} value="Buffalo">{t("Ratibsabhasad.options.buffalo")}</option>
                        <option key={2} value="Cow">{t("Ratibsabhasad.options.cow")}</option>
                    </select>
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>
                        {t("Ratibsabhasad.fields.liter")}
                        <span className='prev'>{Prev.liter ? " (" + Prev.liter + ")" : ''}</span>
                    </span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 4)}
                        ref={ref => (inputRefs.current[4] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                        autoComplete='off'
                        id="liter"
                        name="liter"
                        value={input.liter}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibsabhasad.fields.rate")}</span>
                    <input
                        type="number"
                        className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                        autoComplete='off'
                        id="rate"
                        name="rate"
                        value={input.rate}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibsabhasad.fields.amount")}</span>
                    <input
                        type="number"
                        className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                        autoComplete='off'
                        id="amtratib"
                        name="amt"
                        value={parseFloat(input.amt || 0).toFixed(2)}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <button
                        onClick={saveratibvikri}
                        onKeyDown={e => handleEnterKeybutton(e, 1)}
                        ref={ref => (inputRefs.current[5] = ref)}
                        type="submit"
                        id='saveratibsabh'
                        name='save'
                        className="btn btn-primary mx-1 sanksmall"
                    >
                        {newedit === "new"
                            ? t("Ratibsabhasad.buttons.save")
                            : t("Ratibsabhasad.buttons.update")}
                    </button>
                </div>

                <div className="mb-2 lastimg"></div>
            </div>

            <div className="firstrow2">
                <div className="table-containersank">
                    <table id="myTable" className="table table-bordered">
                        <thead>
                            <tr>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.sr")}</th>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.customerNo")}</th>
                                <th className='thlarge' scope="col">{t("Ratibsabhasad.table.customerName")}</th>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.type")}</th>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.liter")}</th>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.rate")}</th>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.amount")}</th>
                                <th className='thsmall' scope="col">{t("Ratibsabhasad.table.action")}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {value.length > 0 ? tableFilter.map((user, index) =>
                                <tr key={index}>
                                    <td className='thsmall'>{index + 1}</td>
                                    <td className='thsmall'>{user.rno}</td>
                                    <td className='thsmall'>{user.sname}</td>
                                    <td className='thsmall2'>{user.type}</td>
                                    <td className='thsmall'>{user.liter}</td>
                                    <td className='thsmall'>{user.rate}</td>
                                    <td className='thsmall'>{parseFloat(user.amt).toFixed(2)}</td>
                                    <td>
                                        <UilEditAlt
                                            onClick={() => {
                                                handleedit(user.sr, user.date, user.time, user.rno, user.rname, user.type, user.liter, user.fat, user.snf, user.comm, user.rate, user.amt, user.mhcomm, user.gaycomm, user.etype)
                                            }}
                                            className="icsank"
                                        />
                                        <UilTrash
                                            onClick={() => { deletesanklan(user.sr, user.date, user.time, user.sno, user.type) }}
                                            className="icsank"
                                        />
                                    </td>
                                </tr>
                            )
                                :
                                DataSource.map((user, index) =>
                                    <tr key={index}>
                                        <td className='thsmallaudit'>{index + 1}</td>
                                        <td className='thsmallaudit'>{user.rno}</td>
                                        <td className='thsmallaudit'>{user.sname}</td>
                                        <td className='thsmall2'>{user.type}</td>
                                        <td className='thsmallaudit'>{user.liter}</td>
                                        <td className='thsmallaudit'>{user.rate}</td>
                                        <td className='thsmallaudit'>{parseFloat(user.amt).toFixed(2)}</td>
                                        <td>
                                            <UilEditAlt
                                                onClick={() => { handleedit(user.sr, user.date, user.time, user.grtype, user.rno, user.sname, user.type, user.liter, user.rate, user.amt, user.etype) }}
                                                className="icsank"
                                            />
                                            <UilTrash
                                                onClick={() => { deletesanklan(user.sr, user.date, user.time, user.rno, user.type, user.grtype) }}
                                                className="icsank"
                                            />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <div hidden className="tboxbelow">
                {tcust.tliter ? (
                    <span>
                        {tcust.tmh && parseFloat(tcust.tmh) > 0 && (
                            <span>
                                <span className="subheadsank">{t("Ratibsabhasad.summary.buffaloLiter")} </span>
                                <span className="subheadsankgreen"> {tcust.tmh}</span>
                                <span className="subheadsank"> ({t("Ratibsabhasad.summary.avgFat")} </span>{" "}
                                <span className="subheadsank">{tcust.mhavg})</span>
                            </span>
                        )}

                        {tcust.tgay && parseFloat(tcust.tgay) > 0 && (
                            <span>
                                <span className="subheadsank"> | {t("Ratibsabhasad.summary.cowLiter")} </span>
                                <span className="subheadsankgreen"> {tcust.tgay}</span>
                                <span className="subheadsank"> ({t("Ratibsabhasad.summary.avgFat")} </span>{" "}
                                <span className="subheadsank">{tcust.gayavg})</span>
                            </span>
                        )}

                        <span className="subheadsank"> | {t("Ratibsabhasad.summary.totalLiter")} </span>{" "}
                        <span className="subheadsankgreen">{tcust.tliter}</span>
                        <span className="subheadsank"> ({t("Ratibsabhasad.summary.avgFat")} </span>{" "}
                        <span className="subheadsank">{tcust.tavg})</span>
                    </span>
                ) : (
                    <span className="subheadsankgreen">{t("Ratibsabhasad.summary.noEntries")}</span>
                )}
            </div>

            <ToastContainer />
        </div >
    )
}

export default Ratibsabhasad
